/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.PartnerAccountSummaryDetailsResponse, (params: vp.PartnerAccountSummaryDetailsRequest) => void, () => void];

function useFetchPartnerAccountSummaryDetails({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.PartnerAccountSummaryDetailsRequest>({
    Year: '',
    Month: '',
  });
  const [response, setResponse] = useState<vp.PartnerAccountSummaryDetailsResponse>({
    Success: false,
    ErrorMessage: '',
    Year: '',
    Month: '',
    AccountSummary: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.PartnerAccountSummaryDetailsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      
      const res = await api.fetchPartnerAccountSummaryDetails(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.PartnerAccountSummaryDetailsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Year: '',
        Month: '',
        AccountSummary: {},
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchPartnerAccountSummaryDetails);
